import { Box, BoxProps, Button, Menu, MenuButton, MenuDivider, MenuItemOption, MenuList } from '@chakra-ui/react';
import IconArrowDown from 'assets/icons/icon-arrow-simple-down.svg?react';
import { useActiveContentGroups } from 'features/content-groups/hooks/useActiveContentGroups';
import { useNavigate } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

export default function ButtonNewNote(props: BoxProps) {
  const navigate = useNavigate();

  const { data: contentGroups = [] } = useActiveContentGroups();
  const agendaContentGroups = contentGroups.filter(c => c.type === 'AGENDA');
  
  return (
    <Box {...props}>
      <Menu>
        <MenuButton 
          as={Button}
          variant="primary"
          w="full"
          textAlign="left"
          rightIcon={<IconArrowDown />}
        >
          Nova Nota
        </MenuButton>
        <MenuList>
        { agendaContentGroups.map((contentGroup, idx) => (
          <Fragment key={`menu-item-${contentGroup.id}`}>
            <MenuItemOption
              onClick={() => navigate(`/notas-de-agenda/nova/${contentGroup.id}`)}
            >
              { contentGroup.name}
            </MenuItemOption>
            { idx < agendaContentGroups.length-1 && <MenuDivider /> }
          </Fragment>
          ))}
        </MenuList>
      </Menu>
    </Box>
  )
}
